import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Register   from "./components/Register";
import Login      from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AdminPasswordReset from "./components/AdminPasswordReset";
import Header     from "./components/Header";
import HomePage   from "./components/HomePage";
import AddBook    from "./components/AddBook";
import Library    from "./components/Library";
import Journal    from "./components/Journal";
import MyBooks    from "./components/my-books";
import Community  from "./components/community";
import Requests   from "./components/borrowRequest";
import WishList   from "./components/wishlist";
import Profile          from "./components/profile";
import Collections      from "./components/Collections";
import CollectionDetail from "./components/CollectionDetail";
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './AuthContext';

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <>
      <Header />
      <Analytics />
      <main className="App route-enter" key={location.pathname}>
        <Routes location={location}>
          <Route path="/"          element={<HomePage />} />
          <Route path="/register"  element={<Register />} />
          <Route path="/login"     element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/password-reset" element={<AdminPasswordReset />} />
          <Route path="/addbook"   element={<AddBook />} />
          <Route path="/library"   element={<Library />} />
          <Route path="/journal"   element={<Journal />} />
          <Route path="/wishlist"  element={<WishList />} />
          <Route path="/profile"   element={<Profile />} />
          <Route path="/collections"    element={<Collections />} />
          <Route path="/collections/:id" element={<CollectionDetail />} />
          <Route path="/requests"  element={<Requests />} />
          <Route path="/mybooks/:encryptedUserId" element={<MyBooks />} />
          <Route path="/community/:communityId"   element={<Community />} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
